/**
 * lib/storefront/wick_guide/dobule_wicked.js
 */

import Wick from './wick.js';

class DoubleWicked extends Wick {
  static get suffix() {
    return 'Double Wicked';
  }
}

export default DoubleWicked;
